export default "__VITE_ASSET__B5c1rL6$__"